import $ from 'jquery';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Unit from '../Global/_Unit.js';

gsap.registerPlugin(ScrollTrigger);

export default class TextAnim {

  static isComplete = true;

  constructor() {

    // this.ease = this.ease;
    this.ease = 'power4.out';
    this.addDuration = 1;
    this.removeDuration = 0.5;
    this.slideDelayNum = 0.9;

    // this.isComplete = true;
    // 1
    gsap.set('.slideTxt__1-1', { height: 0 });
    gsap.set('.slideTxt__1-2', { height: 0 });
    gsap.set('.slideTxt__1-3', { height: 0 });
    gsap.set('.slideTxt__1-4', { height: 0 });
    // 2
    gsap.set('.slideTxt__2-1', { width: 0 });
    gsap.set('.slideTxt__2-2', { width: 0 });
    // 2 sp
    gsap.set('.slideTxt__2-1--sp', { width: 0 });
    gsap.set('.slideTxt__2-2--sp', { width: 0 });
    gsap.set('.slideTxt__2-3--sp', { width: 0 });
    gsap.set('.slideTxt__2-4--sp', { width: 0 });
    // 3
    gsap.set('.slideTxt__3-1', { height: 0 });
    gsap.set('.slideTxt__3-2', { height: 0 });
    gsap.set('.slideTxt__3-3', { height: 0 });
    gsap.set('.slideTxt__3-4', { height: 0 });
    // 4
    gsap.set('.slideTxt__4-1', { width: 0 });
    gsap.set('.slideTxt__4-2', { width: 0 });
    gsap.set('.slideTxt__4-3', { width: 0 });
    // sp
    gsap.set('.slideTxt__4-1--sp', { width: 0 });
    gsap.set('.slideTxt__4-2--sp', { width: 0 });
    gsap.set('.slideTxt__4-3--sp', { width: 0 });
    gsap.set('.slideTxt__4-4--sp', { width: 0 });
    gsap.set('.slideTxt__4-5--sp', { width: 0 });
    // 5
    gsap.set('.slideTxt__5-1', { height: 0 });
    gsap.set('.slideTxt__5-2', { height: 0 });
    gsap.set('.slideTxt__5-3', { height: 0 });
    // sp
    gsap.set('.slideTxt__5-1--sp', { height: 0 });
    gsap.set('.slideTxt__5-2--sp', { height: 0 });
    gsap.set('.slideTxt__5-3--sp', { height: 0 });
    // 6
    gsap.set('.slideTxt__6-1', { height: 0 });
    gsap.set('.slideTxt__6-2', { height: 0 });
    // sp
    gsap.set('.slideTxt__6-1--sp', { height: 0 });

    // gsap.set('.txtHH img', { opacity: 0 });

  }

  setAni(num) {
    TextAnim.isComplete = false;

    // 1
    const slide1Text1H = $('.slideTxt__1-1 img').height();
    const slide1Text2H = $('.slideTxt__1-2 img').height();
    const slide1Text3H = $('.slideTxt__1-3 img').height();
    const slide1Text4H = $('.slideTxt__1-4 img').height();
    // 2
    const slide2Text1W = $('.slideTxt__2-1 img').width();
    const slide2Text2W = $('.slideTxt__2-2 img').width();
    // 2 sp
    const slide2Text1WSp = $('.slideTxt__2-1--sp img').width();
    const slide2Text2WSp = $('.slideTxt__2-2--sp img').width();
    const slide2Text3WSp = $('.slideTxt__2-3--sp img').width();
    const slide2Text4WSp = $('.slideTxt__2-4--sp img').width();
    // 3
    const slide3Text1H = $('.slideTxt__3-1 img').height();
    const slide3Text2H = $('.slideTxt__3-2 img').height();
    const slide3Text3H = $('.slideTxt__3-3 img').height();
    const slide3Text4H = $('.slideTxt__3-4 img').height();
    // 4
    const slide4Text1W = $('.slideTxt__4-1 img').width();
    const slide4Text2W = $('.slideTxt__4-2 img').width();
    const slide4Text3W = $('.slideTxt__4-3 img').width();
    // sp
    const slide4Text1WSp = $('.slideTxt__4-1--sp img').width();
    const slide4Text2WSp = $('.slideTxt__4-2--sp img').width();
    const slide4Text3WSp = $('.slideTxt__4-3--sp img').width();
    const slide4Text4WSp = $('.slideTxt__4-4--sp img').width();
    const slide4Text5WSp = $('.slideTxt__4-5--sp img').width();
    // 5
    const slide5Text1W = $('.slideTxt__5-1 img').height();
    const slide5Text2W = $('.slideTxt__5-2 img').height();
    const slide5Text3W = $('.slideTxt__5-3 img').height();
    // sp
    const slide5Text1WSp = $('.slideTxt__5-1--sp img').height();
    const slide5Text2WSp = $('.slideTxt__5-2--sp img').height();
    const slide5Text3WSp = $('.slideTxt__5-3--sp img').height();
    // 6
    const slide6Text1W = $('.slideTxt__6-1 img').height();
    const slide6Text2W = $('.slideTxt__6-2 img').height();
    // sp
    const slide6Text1WSp = $('.slideTxt__6-1--sp img').height();



    if (num == 1) {
      gsap.to('.slideTxt__1-1', { height: slide1Text1H , duration: this.addDuration, ease: this.ease, delay: 0 + this.slideDelayNum });
      gsap.to('.slideTxt__1-2', { height: slide1Text2H , duration: this.addDuration, ease: this.ease, delay: 0.2 + this.slideDelayNum });
      gsap.to('.slideTxt__1-3', { height: slide1Text3H , duration: this.addDuration, ease: this.ease, delay: 0.4 + this.slideDelayNum });
      gsap.to('.slideTxt__1-4', { height: slide1Text4H , duration: this.addDuration, ease: this.ease, delay: 0.6 + this.slideDelayNum, onComplete: this.animComplete});
    } else if (num == 2) {
      if(Unit.isPc()) {
        gsap.to('.slideTxt__2-1', { width: slide2Text1W , duration: this.addDuration, ease: this.ease, delay: 0 + this.slideDelayNum });
        gsap.to('.slideTxt__2-2', { width: slide2Text2W , duration: this.addDuration, ease: this.ease, delay: 0.2 + this.slideDelayNum, onComplete: this.animComplete});
      } else {
        // sp
        gsap.to('.slideTxt__2-1--sp', { width: slide2Text1WSp , duration: this.addDuration, ease: this.ease, delay: 0 + this.slideDelayNum });
        gsap.to('.slideTxt__2-2--sp', { width: slide2Text2WSp , duration: this.addDuration, ease: this.ease, delay: 0.2 + this.slideDelayNum });
        gsap.to('.slideTxt__2-3--sp', { width: slide2Text3WSp , duration: this.addDuration, ease: this.ease, delay: 0.4 + this.slideDelayNum });
        gsap.to('.slideTxt__2-4--sp', { width: slide2Text4WSp , duration: this.addDuration, ease: this.ease, delay: 0.6 + this.slideDelayNum, onComplete: this.animComplete});
      }
    } else if (num == 3) {
      gsap.to('.slideTxt__3-1', { height: slide3Text1H , duration: this.addDuration, ease: this.ease, delay: 0 + this.slideDelayNum });
      gsap.to('.slideTxt__3-2', { height: slide3Text2H , duration: this.addDuration, ease: this.ease, delay: 0.2 + this.slideDelayNum });
      gsap.to('.slideTxt__3-3', { height: slide3Text3H , duration: this.addDuration, ease: this.ease, delay: 0.4 + this.slideDelayNum });
      gsap.to('.slideTxt__3-4', { height: slide3Text4H , duration: this.addDuration, ease: this.ease, delay: 0.6 + this.slideDelayNum, onComplete: this.animComplete});
    } else if (num == 4) {
      if(Unit.isPc()) {
        gsap.to('.slideTxt__4-1', { width: slide4Text1W , duration: this.addDuration, ease: this.ease, delay: 0 + this.slideDelayNum });
        gsap.to('.slideTxt__4-2', { width: slide4Text2W , duration: this.addDuration, ease: this.ease, delay: 0.2 + this.slideDelayNum });
        gsap.to('.slideTxt__4-3', { width: slide4Text3W , duration: this.addDuration, ease: this.ease, delay: 0.4 + this.slideDelayNum, onComplete: this.animComplete});
      } else {
        // sp
        gsap.to('.slideTxt__4-1--sp', { width: slide4Text1WSp , duration: this.addDuration, ease: this.ease, delay: 0 + this.slideDelayNum });
        gsap.to('.slideTxt__4-2--sp', { width: slide4Text2WSp , duration: this.addDuration, ease: this.ease, delay: 0.2 + this.slideDelayNum });
        gsap.to('.slideTxt__4-3--sp', { width: slide4Text3WSp , duration: this.addDuration, ease: this.ease, delay: 0.4 + this.slideDelayNum });
        gsap.to('.slideTxt__4-4--sp', { width: slide4Text4WSp , duration: this.addDuration, ease: this.ease, delay: 0.6 + this.slideDelayNum });
        gsap.to('.slideTxt__4-5--sp', { width: slide4Text5WSp , duration: this.addDuration, ease: this.ease, delay: 0.8 + this.slideDelayNum, onComplete: this.animComplete});
      }
    } else if (num == 5) {
      if(Unit.isPc()) {
        gsap.to('.slideTxt__5-1', { height: slide5Text1W , duration: this.addDuration, ease: this.ease, delay: 0 + this.slideDelayNum });
        gsap.to('.slideTxt__5-2', { height: slide5Text2W , duration: this.addDuration, ease: this.ease, delay: 0.2 + this.slideDelayNum });
        gsap.to('.slideTxt__5-3', { height: slide5Text3W , duration: this.addDuration, ease: this.ease, delay: 0.4 + this.slideDelayNum, onComplete: this.animComplete});
      } else {
        // sp
        gsap.to('.slideTxt__5-1--sp', { height: slide5Text1WSp , duration: this.addDuration, ease: this.ease, delay: 0 + this.slideDelayNum });
        gsap.to('.slideTxt__5-2--sp', { height: slide5Text2WSp , duration: this.addDuration, ease: this.ease, delay: 0.2 + this.slideDelayNum });
        gsap.to('.slideTxt__5-3--sp', { height: slide5Text3WSp , duration: this.addDuration, ease: this.ease, delay: 0.4 + this.slideDelayNum, onComplete: this.animComplete});
      }
    } else if (num == 6) {
      if(Unit.isPc()) {
        gsap.to('.slideTxt__6-1', { height: slide6Text1W , duration: this.addDuration, ease: this.ease, delay: 0 + this.slideDelayNum });
        gsap.to('.slideTxt__6-2', { height: slide6Text2W , duration: this.addDuration, ease: this.ease, delay: 0.2 + this.slideDelayNum });
        gsap.fromTo('.txtHH img', { opacity: 0, y: +100 }, { opacity: 1, y: 0, duration: this.addDuration, ease: 'expo.out', duration: 1, delay: 0.6 + this.slideDelayNum, onComplete: this.animComplete});
      } else {
        // sp
        gsap.to('.slideTxt__6-1--sp', { height: slide6Text1WSp , duration: this.addDuration, ease: this.ease, delay: 0 + this.slideDelayNum, onComplete: this.animComplete});
        // gsap.fromTo('.hebi__containerTxt', { opacity: 0, y: +100 }, { opacity: 1, y: 0, duration: this.addDuration, ease: 'expo.out', duration: 1, delay: 0.6 + this.slideDelayNum, onComplete: this.animComplete});
      }
    }

  }

  removeAni(num) {

    // ENDのときは消さない
    if (num == 7) return false;
    // return false;

    // 1
    gsap.to('.slideTxt__1-1', { height: 0 , duration: this.removeDuration, ease: 'expo.out' });
    gsap.to('.slideTxt__1-2', { height: 0 , duration: this.removeDuration, ease: 'expo.out' });
    gsap.to('.slideTxt__1-3', { height: 0 , duration: this.removeDuration, ease: 'expo.out' });
    gsap.to('.slideTxt__1-4', { height: 0 , duration: this.removeDuration, ease: 'expo.out' });
    // 2
    gsap.to('.slideTxt__2-1', { width: 0 , duration: this.removeDuration, ease: 'expo.out' });
    gsap.to('.slideTxt__2-2', { width: 0 , duration: this.removeDuration, ease: 'expo.out' });
    // sp
    gsap.to('.slideTxt__2-1--sp', { width: 0 , duration: this.removeDuration, ease: 'expo.out' });
    gsap.to('.slideTxt__2-2--sp', { width: 0 , duration: this.removeDuration, ease: 'expo.out' });
    gsap.to('.slideTxt__2-3--sp', { width: 0 , duration: this.removeDuration, ease: 'expo.out' });
    gsap.to('.slideTxt__2-4--sp', { width: 0 , duration: this.removeDuration, ease: 'expo.out' });
    // 3
    gsap.to('.slideTxt__3-1', { height: 0 , duration: this.removeDuration, ease: 'expo.out' });
    gsap.to('.slideTxt__3-2', { height: 0 , duration: this.removeDuration, ease: 'expo.out' });
    gsap.to('.slideTxt__3-3', { height: 0 , duration: this.removeDuration, ease: 'expo.out' });
    gsap.to('.slideTxt__3-4', { height: 0 , duration: this.removeDuration, ease: 'expo.out' });
    // 4
    gsap.to('.slideTxt__4-1', { width: 0 , duration: this.removeDuration, ease: 'expo.out' });
    gsap.to('.slideTxt__4-2', { width: 0 , duration: this.removeDuration, ease: 'expo.out' });
    gsap.to('.slideTxt__4-3', { width: 0 , duration: this.removeDuration, ease: 'expo.out' });
    // sp
    gsap.to('.slideTxt__4-1--sp', { width: 0 , duration: this.removeDuration, ease: 'expo.out' });
    gsap.to('.slideTxt__4-2--sp', { width: 0 , duration: this.removeDuration, ease: 'expo.out' });
    gsap.to('.slideTxt__4-3--sp', { width: 0 , duration: this.removeDuration, ease: 'expo.out' });
    gsap.to('.slideTxt__4-4--sp', { width: 0 , duration: this.removeDuration, ease: 'expo.out' });
    gsap.to('.slideTxt__4-5--sp', { width: 0 , duration: this.removeDuration, ease: 'expo.out' });
    // 5
    gsap.to('.slideTxt__5-1', { height: 0 , duration: this.removeDuration, ease: 'expo.out' });
    gsap.to('.slideTxt__5-2', { height: 0 , duration: this.removeDuration, ease: 'expo.out' });
    gsap.to('.slideTxt__5-3', { height: 0 , duration: this.removeDuration, ease: 'expo.out' });
    // sp
    gsap.to('.slideTxt__5-1--sp', { height: 0 , duration: this.removeDuration, ease: 'expo.out' });
    gsap.to('.slideTxt__5-2--sp', { height: 0 , duration: this.removeDuration, ease: 'expo.out' });
    gsap.to('.slideTxt__5-3--sp', { height: 0 , duration: this.removeDuration, ease: 'expo.out' });
    // 6
    gsap.to('.slideTxt__6-1', { height: 0 , duration: this.removeDuration, ease: 'expo.out' });
    gsap.to('.slideTxt__6-2', { height: 0 , duration: this.removeDuration, ease: 'expo.out' });
    // sp
    gsap.to('.slideTxt__6-1--sp', { height: 0 , duration: this.removeDuration, ease: 'expo.out' });

    gsap.to('.txtHH img', { opacity: 0, y: +100 , duration: this.removeDuration, ease: 'expo.out' });
    // gsap.to('.hebi__containerTxt', { opacity: 0, y: +100 , duration: this.removeDuration, ease: 'expo.out' });//sp
  }

  animComplete() {
    TextAnim.isComplete = true;

    ScrollTrigger.refresh();
  }

  isCompleted() {
    return TextAnim.isComplete;
  }
}
